module.exports = __webpack_public_path__ + "static/media/message-circle.1d50906d.svg";